module.exports = __webpack_public_path__ + "media/MRI-exemplo-ad.011d72ee.mp3";